import { useCallback, useEffect, useState } from 'react';
import { trackEvent } from '../lib/firebase';

const KEY = 'today_theme';

function getInitial() {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // Default to user's OS preference if no explicit choice
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

// Apply synchronously at module-load so the initial paint matches the stored
// preference and avoids a light-to-dark flash on first render.
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-theme', getInitial());
}

export default function useTheme() {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      trackEvent('theme_toggle', { theme: next });
      return next;
    });
  }, []);

  return { theme, toggle, isDark: theme === 'dark' };
}
